import { PageScheme } from '@/config/types';

import { DYNAMIC_PAGE_PATHS } from '../../shared/pathRoutes';

export const PAGE_BORROWER: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.BORROWER,
  schemesByRoles: [
    {
      roles: [],
      titleTextId: 'BORROWER_DETAIL',
      widgets: [],
    },
  ],
  sections: [
    // {
    //   textId: 'OVERVIEW',
    //   schemesByRoles: [
    //     {
    //       roles: [...ALL_APP_ROLES],
    //       modules: ['<BorrowerOverviewModule />'],
    //     },
    //   ],
    // },
    // {
    //   textId: 'KYC PERSONAL INFORMATION',
    //   schemesByRoles: [
    //     {
    //       roles: [...ALL_APP_ROLES],
    //       modules: ['<DocumentId />'],
    //     },
    //   ],
    // },
  ],
};
